import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    darkMode: false,
    navigationItems: [],
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setDarkMode(state, darkMode) {
      state.darkMode = darkMode;
      localStorage.setItem('darkMode', JSON.stringify(darkMode));
    },
    setNavigationItems(state, items) {
      state.navigationItems = items;
    },
  },
  actions: {
    async fetchUser({ commit }) {
      try {
        const response = await axios.get('/api/user');
        commit('setUser', response.data[0]);
      } catch (error) {
        // Handle error
      }
    },
    async fetchNavigationItems({ commit }) {
      try {
        const response = await axios.get('/api/navigation');
        commit('setNavigationItems', response.data);
      } catch (error) {
        // Handle error
      }
    },
    setDarkMode({ commit }, darkMode) {
      commit('setDarkMode', darkMode);
    },
    logoutUser({ commit }) {
      axios.get('/api/logout').then(() => {
        commit('setUser', null);
      });
    },
  },
  getters: {
    isAuthenticated: state => !!state.user,
    user: state => state.user,
  },
});
